import React from 'react';
import FilesWrapper from '../Files/FilesWrapper';

const FileSelection = props => {
  return <FilesWrapper config={{ mode: 'lite', selector: props }} />;
};

export default FileSelection;
